import { createBlueprint as e } from "@made-people/blueprint";
const r = e({
  slots: {
    heading: "text-heading-md text-left pt-12 pb-4 px-8 w-full",
    searchInputWrapper: "grid grid-cols-12 lg:grid-cols-15 gap-x-3 lg:gap-x-6 gap-y-8 px-component-x-spacing-xs lg:px-component-x-spacing-md w-full pt-8"
  },
  variants: {}
}), o = e({
  slots: {
    wrapper: "h-10 w-full relative col-span-12 lg:col-start-1 lg:col-end-7 row-span-1 order-2 caret-black",
    inputField: "h-full w-full pl-10 lg:pl-12 pr-4 bg-surface-1 bg-black/5 border-border-light focus:border-border-light caret-black focus:caret-black focus-within:outline-black/20 focus-within:outline-1 rounded-lg",
    iconSearch: "absolute size-[18px] aspect-square left-3 top-[11px]",
    iconLoading: "absolute size-8 aspect-square right-1.5 top-1",
    clearText: "absolute size-8 right-1.5 top-1"
  },
  variants: {
    color: {
      white: {
        inputField: ""
      },
      grey: {
        inputField: ""
      }
    }
  }
}), s = e({
  slots: {
    wrapper: "bg-white rounded-2xl py-6 absolute w-full mt-2 shadow-lg border-2 border-neutral-100 overflow-y-auto max-h-[300px] lg:max-h-[unset]",
    heading: "px-6",
    resultList: "mt-4",
    itemImage: "block size-8",
    itemLabel: "",
    item: "w-full flex items-center h-11 gap-2 px-6 hover:bg-neutral-100 text-body-sm font-medium",
    emptyStateWrapper: "flex flex-col items-center justify-center h-40 gap-2",
    emptyStateHeading: "",
    loading: "text-center text-lg"
  },
  variants: {}
}), l = e({
  slots: {
    heading: "text-heading-md lg:text-heading-lg text-left col-span-12 order-1",
    noResultsHeadingWrapper: "col-span-12",
    upperSectionWrapper: "pt-6 pb-2 grid grid-cols-12 gap-x-3 lg:gap-x-6 gap-y-6 px-5 lg:px-12 w-full"
  },
  variants: {}
}), n = e({
  slots: {
    categorySuggestionsHeading: "mb-3 lg:mb-4",
    categorySuggestions: "grid grid-cols-2 gap-3 lg:grid-cols-3",
    categorySuggestionsButton: "w-full text-left p-3 rounded-none border border-border-light hover:border-black transition-colors duration-150 focus:outline-none focus:border-black",
    categorySuggestionsContent: "flex flex-col items-center gap-2",
    categorySuggestionsImageContainer: "w-full aspect-square overflow-hidden rounded-none bg-background-surface-1",
    categorySuggestionsImage: "w-full h-full object-cover",
    categorySuggestionsAncestors: "flex flex-wrap gap-1 text-xs text-text-less-emphasis-2 text-center",
    categorySuggestionsTitle: "text-sm font-medium text-center line-clamp-2 text-text-body"
  },
  variants: {}
}), a = e({
  slots: {
    linkSuggestionsHeading: "mb-3 lg:mb-4",
    linkSuggestions: "flex flex-col gap-2",
    linkSuggestionsButton: "underline cursor-pointer"
  },
  variants: {}
}), i = e({
  slots: {
    suggestionlist: "flex flex-col gap-2",
    suggestionListButton: "text-left text-sm text-text-secondary hover:text-text-primary focus:text-text-primary focus:outline-none",
    heading: "text-lg font-semibold text-text-primary mb-2"
  },
  variants: {}
}), g = e({
  slots: {
    productSuggestionList: "grid grid-cols-2 gap-3 mb-2 w-full",
    heading: "text-lg font-semibold text-text-primary mb-2"
  },
  variants: {}
}), c = e({
  slots: {
    recentSearches: "flex flex-col gap-2",
    recentSearchesButton: "text-left text-sm text-text-secondary hover:text-text-primary focus:text-text-primary focus:outline-none",
    recentSearchesHeading: "text-lg font-semibold text-text-primary mb-3 lg:mb-4"
  },
  variants: {}
}), p = e({
  slots: {
    wrapper: "text-center items-center flex flex-col gap-10 mb-10 md:mb-16 lg:mb-20",
    searchInput: "max-w-component-max-w-sm",
    heading: ""
  },
  variants: {}
});
export {
  n as categorySuggestionsListBlueprint,
  a as linkSuggestionsListBlueprint,
  i as phraseSuggestionListBlueprint,
  c as recentSearchesListBlueprint,
  s as searchAutocompleteBlueprint,
  l as searchBeijingBlueprint,
  o as searchInputBlueprint,
  g as searchProductListBlueprint,
  p as searchResultsHeaderBlueprint,
  r as searchShanghaiBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
